const initialState = {
    loading: false,
    job: null,
    jobs: [],

}
export default function (state = initialState, action) {
    switch (action.type) {
        case "GET_JOB":
            return { ...state, job: action.payload }
        case "GET_JOB_ERROR":
            return { ...state, loading: false }
        case "GET_JOBS":
            return { ...state, jobs: action.payload }
        case "DELETE_JOB":
            const jobDelete = state.jobs.filter(job => job._id !== action.payload)
            return { ...state, jobs: jobDelete }

        default:
            return state

    }
}
